import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { SearchPages, SearchWebsite } from "../../Constant";
import SearchInput from "./SearchInput";
import SearchTabs from "./SearchTabs";
import { useCallback, useState } from "react";
import SearchTabContent from "./TabContent/SearchTabContent";

const SearchResultContainer = () => {
  const [activeTab, setActiveTab] = useState(1);
  const callback = useCallback((tab: number) => {
    setActiveTab(tab);
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={SearchWebsite} parent={SearchPages} title={SearchWebsite} />
      <Container fluid className="search-page">
        <Row>
          <Col sm="12">
            <Card>
              <SearchInput />
              <CardBody>
                <SearchTabs callbackActive={callback} activeTabValue={1} />
                <SearchTabContent activeTab={activeTab} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SearchResultContainer;
